function loadSplide() {
  var splide = new Splide('.about-timeline .splide' , {
    pagination: false,
    arrows: false,
    autoplay: 'play',
    perPage : 3,
    perMove : 1,
    padding: { right: '10%' },
    pauseOnHover: false,
    pauseOnFocus: false,
    breakpoints: {
      750: {
        perPage: 2,
        padding: { right: '12%' },
      },
    },
  });

  var bar = splide.root.querySelector( '.timeline-progress-bar' );
  // Updates the bar width whenever the carousel moves:
  splide.on( 'mounted move', function () {
    var end  = splide.Components.Controller.getEnd() + 1;
    var rate = Math.min( ( splide.index + 1 ) / end, 1 );
    bar.style.width = String( 100 * rate ) + '%';
    
  } );
  splide.mount();
}

document.addEventListener( 'DOMContentLoaded', loadSplide);

if (!window.loadSplideInitialized) {
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.about-timeline')) {
      loadSplide();
    }
  });
  window.loadSplideInitialized = true;
}
